
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80","viewBox":"0 0 96 96"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"user","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}},[_c('path',{attrs:{"d":"M67.989 27.986A19.99 19.99 0 1148 7.996a19.99 19.99 0 0119.989 19.99z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M82.367 88.004c0-15.472-15.403-27.985-34.367-27.985S13.633 72.532 13.633 88.004"}})])])
          )
        }
      }
    